"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    fill: "currentColor",
    width: "100%",
    height: "100%",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 391.54 222.65",
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M365.49,345.4v-140A12.4,12.4,0,0,0,353.1,193H184.67a6.2,6.2,0,0,0,0,12.39H353.1v128.8c0,.13,0,.25,0,.38V345.4H140.61a6.2,6.2,0,0,0,0,12.39h65.7v0H365.49Z",
      transform: "translate(-133.73 -192.98)"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M169.64,236.25H270.22a6.19,6.19,0,1,0,0-12.38H169.64a6.19,6.19,0,0,0,0,12.38Z",
      transform: "translate(-133.73 -192.98)"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M154.78,266H255.36a6.2,6.2,0,0,0,0-12.39H154.78a6.2,6.2,0,0,0,0,12.39Z",
      transform: "translate(-133.73 -192.98)"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M139.92,295.7H240.5a6.2,6.2,0,0,0,0-12.39H139.92a6.2,6.2,0,0,0,0,12.39Z",
      transform: "translate(-133.73 -192.98)"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M515.3,305,470.19,295V269.31a20.68,20.68,0,0,0-20.66-20.65H432.77l-37.7,0a6.19,6.19,0,0,0-6.18,5.93c0,.09,0,96.54,0,96.54a6.19,6.19,0,0,0,12.38,0V261h48.26a8.29,8.29,0,0,1,8.28,8.27V305l54.76,12.05a2.35,2.35,0,0,1,.32.32v51.85H497.94l-.7,5.39a32.92,32.92,0,0,1-65.28,0l-.7-5.39-118.91.1-.72,5.37a32.91,32.91,0,0,1-60.14,13.71l-5.16-7.83-5.17,7.83a32.92,32.92,0,0,1-60.1-13.34v0l0-6h0a1.1,1.1,0,0,0,0-.18,6.16,6.16,0,1,0-12.32,0c0,.06,0,.12,0,.18h-.06l0,6v.51l0,.79a45.29,45.29,0,0,0,77.59,25.37,45.28,45.28,0,0,0,76.53-20l97.88-.08a45.29,45.29,0,0,0,87.74,0h5.37a11.44,11.44,0,0,0,11.43-11.42V317.37A12.94,12.94,0,0,0,515.3,305Z",
      transform: "translate(-133.73 -192.98)"
    })]
  });
};

exports.default = Icon;